import { useLang, MARQUEE_ITEMS } from "../i18n";

function Row({ items, row }) {
  return (
    <div className="flex shrink-0 items-center">
      {items.map((d, i) => (
        <span key={`${row}-${i}`} className="flex items-center">
          <span className="font-serif italic text-lg sm:text-xl text-champagne/90 whitespace-nowrap px-6">{d}</span>
          <svg viewBox="0 0 64 64" className="w-3.5 h-3.5 shrink-0" aria-hidden="true">
            <g fill="#A9C29A">
              <ellipse cx="32" cy="41" rx="11" ry="9" />
              <ellipse cx="19" cy="28" rx="5" ry="6.5" transform="rotate(-18 19 28)" />
              <ellipse cx="45" cy="28" rx="5" ry="6.5" transform="rotate(18 45 28)" />
              <ellipse cx="26.5" cy="21" rx="4.5" ry="6" />
              <ellipse cx="37.5" cy="21" rx="4.5" ry="6" />
            </g>
          </svg>
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  const { lang } = useLang();
  const items = MARQUEE_ITEMS[lang];
  return (
    <div className="bg-[#0B0F0C] py-5 overflow-hidden border-y border-white/10" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        <Row items={items} row="a" />
        <Row items={items} row="b" />
      </div>
    </div>
  );
}
